import { Range } from 'react-date-range';
import { LuSearchX } from 'react-icons/lu';

import { formatDateToBR } from 'helpers';

interface EmptyResultProps {
  dateRange: Range;
}

export function EmptyResult(props: EmptyResultProps) {
  const { dateRange } = props;
  const { startDate, endDate } = dateRange;

  return (
    <div
      className="flex w-full gap-4 p-4 rounded-lg bg-warning-300/10 border-solid border
        border-warning-500"
    >
      <LuSearchX className="w-12 h-12 text-warning-500" />
      <div className="flex flex-col justify-center flex-grow gap-1.5">
        <p className="text-sm font-bold text-neutral-500">
          Não foram encontradas movimentações no período consultado
        </p>
        <p className="text-xs text-neutral-500">
          Consulta de{' '}
          <span className="font-bold">
            {formatDateToBR(startDate)} a {formatDateToBR(endDate)}
          </span>
        </p>
      </div>
    </div>
  );
}
